export default __webpack_public_path__ + "static/media/doh.3d8dc17f.png";